import { InjectionToken } from '@angular/core';
import { ICaptureSessionsService } from '../../interfaces/services/capture-sessions-service.interface';

export const CAPTURE_SESSIONS_SERVICE = new InjectionToken<ICaptureSessionsService>('CaptureSessionsService');
